import { Component, Injector, OnInit, Input, AfterViewInit } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { LinkedUserDto, ProfileServiceProxy, TokenAuthServiceProxy, UserLinkServiceProxy } from '@shared/service-proxies/service-proxies';
import { LinkedAccountService } from '@app/shared/layout/linked-account.service';
import { AbpMultiTenancyService, AbpSessionService } from 'abp-ng2-module';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AppConsts } from '@shared/AppConsts';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { Router } from '@angular/router';
import { AppPreBootstrap } from 'AppPreBootstrap';
import { HttpClient } from '@angular/common/http';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import { LocalStorageService } from '@shared/utils/local-storage.service';


@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
})
export class UserMenuComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit {
    @Input() iconOnly = false;

    @Input() togglerCssClass = 'btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2';
    @Input() textCssClass = 'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3';
    @Input() symbolCssClass = 'symbol symbol-35 symbol-light-success';
    @Input() symbolTextCssClass = 'symbol-label font-size-h5 font-weight-bold';

    usernameFirstLetter = '';

    profilePicture = AppConsts.appBaseUrl + '/assets/common/images/default-profile-picture.png';
    shownLoginName = '';
    tenancyName = '';
    userName = '';

    recentlyLinkedUsers: LinkedUserDto[];
    isImpersonatedLogin = false;
    isMultiTenancyEnabled = false;

    mQuickUserOffcanvas: any;

    public constructor(
        injector: Injector,
        private _router: Router,
        private _httpClient: HttpClient,
        private _linkedAccountService: LinkedAccountService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _impersonationService: ImpersonationService,
        private _abpSessionService: AbpSessionService,
        private _tokenAuthService: TokenAuthServiceProxy,
        _dateTimeService: DateTimeService,

    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit(): void {
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;
        this.isMultiTenancyEnabled = this._abpMultiTenancyService.isEnabled;
        this.setCurrentLoginInformations();
        this.getProfilePicture();
        this.getRecentlyLinkedUsers();
        this.registerToEvents();
        this.usernameFirstLetter = this.appSession.user.userName.substring(0, 1).toUpperCase();
    }

    ngAfterViewInit(): void {
        this.mQuickUserOffcanvas = new KTOffcanvas('kt_quick_user', {
            overlay: true,
            baseClass: 'offcanvas',
            placement: 'right',
            closeBy: 'kt_demo_panel_close',
            toggleBy: ['kt_quick_user_toggle', 'ShowLoginAttemptsLink'],
        });

        this.mQuickUserOffcanvas.events.push({
            name: 'beforeShow',
            handler: () => {
                abp.event.trigger('app.show.quickUserPanel');
            },
        });
    }

    setCurrentLoginInformations(): void {
        this.shownLoginName = this.appSession.user.name; //.getShownLoginName();
        this.tenancyName = this.appSession.tenancyName;
        this.userName = this.appSession.user.userName;
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (linkedUser.tenantId ? linkedUser.tenancyName : '.') + '\\' + linkedUser.username;
    }

    getProfilePicture(): void {
        this._profileServiceProxy.getProfilePicture().subscribe((result) => {
            if (result && result.profilePicture) {
                this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
            }
        });
    }

    getRecentlyLinkedUsers(): void {
        this._userLinkServiceProxy.getRecentlyUsedLinkedUsers().subscribe((result) => {
            this.recentlyLinkedUsers = result.items;
        });
    }

    getAuthTokenFromLocalStorage(): Promise<string> {
        return new Promise((resolve, reject) => {
            var _localStorageService = new LocalStorageService();
            _localStorageService.getItem('Abp.AuthToken', (err, value) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(value?.token);
                }
            });
        });
    }

    async openPowerBi(): Promise<void> {
        let token: string | undefined = abp.auth.getToken();//this will not work with httpOnly cookie
        if (!token || token === '') {
            token = await this.getAuthTokenFromLocalStorage();
        }

        let returnUrl = '';
        if (AppConsts.powerBiReturnUrl && AppConsts.powerBiReturnUrl != '')
            returnUrl = 'ReturnUrl=' + AppConsts.powerBiReturnUrl;
        let fullUrl = AppConsts.powerBiUrl + '/logon.aspx?' + returnUrl + '&t=' + token;
        abp.log.info('PowerBi full url:  ' + fullUrl);
        window.open(fullUrl, "_blank");

        // const xhr = new XMLHttpRequest();
        // xhr.open('GET', reportServerUrl, true);
        // xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        // xhr.onreadystatechange = () => {
        // if (xhr.readyState === 4 && xhr.status === 200) {
        // const newTab = window.open('about:blank', '_blank');
        // newTab.location.href = reportServerUrl;
        // }
        // };
        // xhr.send();

        // const token = abp.auth.getToken();
        // const reportServerUrl = AppConsts.powerBiUrl;

        // const httpOptions = {
        //     headers: {
        //         Authorization: `Bearer ${token}`
        //     }
        // };

        // let customHeaders = [
        //     {
        //         name: 'Access-Control-Allow-Origin',
        //         value: '*',
        //     },
        //     {
        //         name: 'Authorization',
        //         value: `Bearer ${token}`,
        //     },
        // ];

        // //let requestHeaders = AppPreBootstrap.getRequetHeadersWithDefaultValues();

        // XmlHttpRequestHelper.ajax(
        //     'POST',
        //     AppConsts.powerBiUrl ,
        //         customHeaders,
        //     null,
        //     (response) => {
        //         // let result = response.result;
        //         // abp.auth.setToken(result.accessToken);
        //         // AppPreBootstrap.setEncryptedTokenCookie(result.encryptedAccessToken, () => {
        //         //     callback();
        //         //     location.search = '';
        //         // });
        //     }
        // );

        // XmlHttpRequestHelper.ajax(
        //     'POST',
        //     AppConsts.appBaseUrl +
        //         '/api/TokenAuth/OpenPowerBi?token=' + token,
        //         customHeaders,
        //     null,
        //     (response) => {
        //         let result = response.result;
        //         // abp.auth.setToken(result.accessToken);
        //         // AppPreBootstrap.setEncryptedTokenCookie(result.encryptedAccessToken, () => {
        //         //     callback();
        //         //     location.search = '';
        //         // });
        //     }
        // );

        // this._httpClient.get(reportServerUrl, httpOptions).subscribe(() => {
        //     window.open(reportServerUrl, '_blank'); // Open in a new tab or window
        // });

        // let requestHeaders = AppPreBootstrap.getRequetHeadersWithDefaultValues();

        // if (token) {
        //     requestHeaders['Authorization'] = 'Bearer ' + token;
        // }
        //this._router.navigate(['/app/admin/login-attempts']);
    }

    showLinkedAccounts(): void {
        abp.event.trigger('app.show.linkedAccountsModal');
    }

    showUserDelegations(): void {
        abp.event.trigger('app.show.userDelegationsModal');
    }

    changePassword(): void {
        abp.event.trigger('app.show.changePasswordModal');
    }

    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    changeMySettings(): void {
        abp.event.trigger('app.show.mySettingsModal');
    }

    registerToEvents() {
        this.subscribeToEvent('profilePictureChanged', () => {
            this.getProfilePicture();
        });

        this.subscribeToEvent('app.getRecentlyLinkedUsers', () => {
            this.getRecentlyLinkedUsers();
        });

        this.subscribeToEvent('app.onMySettingsModalSaved', () => {
            this.onMySettingsModalSaved();
        });
    }

    logout(): void {
        this._authService.logout();
    }

    onMySettingsModalSaved(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(linkedUser.id, linkedUser.tenantId);
    }

    downloadCollectedData(): void {
        this._profileServiceProxy.prepareCollectedData().subscribe(() => {
            this.message.success(this.l('GdprDataPrepareStartedNotification'));
        });
    }

    viewProfile(): void {
        this._router.navigate(['/app/admin/users/view'], { queryParams: { id: this.appSession.user.id } });
    }
}
